<script>
    import DatePeriod from "../date/DatePeriod.svelte";
    import EventLocationName from "./EventLocationName.svelte";
    import EventEditButton from "./EventEditButton.svelte";

    export let event;

    let imageUrl = '/images/event-example.png';
    if (event.image_url) {
        imageUrl = event.image_url.replace('https://s3-eu-west-1.amazonaws.com/imin-uploads/images/https://', 'https://');
    }
</script>

<img src={ imageUrl } class="img-fluid" alt="Image of the event, likely a banner or atmosphere image.">